import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    actions: {
        async loadColumns(ctx) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/columns&user_id=${userId}`, token)
            );

            const json = await res.json();

            return json;
        },

    }
};
